<ng-container *ngIf="state$ | async; let state">
    <ng-container *ngIf="validity$ | async; let validity">
        <form [formGroup]="form">
            <div class="zas-row">
                <zbd-input
                    type="checkbox"
                    name="hasGoals"
                    label="Wünsche und Ziele"
                    class="zas-main-col"
                    [entity]="state.globalOccasion"
                    property="Goals"
                    [updateFn]="persistence.updateGlobalOccasion"
                ></zbd-input>
            </div>
            <div class="zas-row">
                <zbd-list
                    label="Der Kunde wurde anhand seiner Wünsche und Ziele aufgrund der Analyse an folgenden Tagen beraten:"
                    itemName="Datum"
                    class="zas-main-col"
                    itemWidth="200px"
                    [collection]="state.globalOccasion.ConsultationDates"
                    [template]="date"
                    [addFn]="addConsultationDate_(state.globalOccasion)"
                    [deleteFn]="persistence.deleteConsultationDate"
                    [validity]="validity"
                ></zbd-list>
            </div>
            <div class="zas-row">
                <zbd-input
                    type="textarea"
                    name="remarks"
                    rows="2"
                    label="Anmerkung"
                    class="zas-main-col"
                    [entity]="state.globalOccasion"
                    property="Remarks"
                    [updateFn]="persistence.updateGlobalOccasion"
                ></zbd-input>
            </div>

            <attachments
                [attachments]="state.globalOccasion.Attachments"
                [addAttachmentFun]="addAttachment(state.globalOccasion)"
            ></attachments>

            <zbd-global-occasion-section-list
                [persistence]="persistence"
                [state$]="state$"
                [validity]="validity"
            >
            </zbd-global-occasion-section-list>
        </form>
    </ng-container>
</ng-container>

<ng-template #date let-item let-validity="validity">
    <zbd-input
        type="date"
        [name]="item.Id"
        class="list-item"
        [entity]="item"
        property="Date"
        [updateFn]="persistence.updateConsultationDate"
        [validity]="validity.consultationDates"
    ></zbd-input>
</ng-template>
